import a from "react";
import o from "classnames";
import { QRCodeCanvas as m } from "qrcode.react";
import s from "./qrCode.module.scss.js";
function n({
  data: e,
  size: r,
  className: t
}) {
  return /* @__PURE__ */ a.createElement(
    m,
    {
      "data-testid": "qr-code",
      className: o(s.qr, t),
      value: e,
      size: r,
      includeMargin: !0
    }
  );
}
export {
  n as QrCode
};
//# sourceMappingURL=QrCode.js.map
